<template>
  <div class="bg">
    <div class="top_search_part">
      <div class="search_box">
        <div class="search_item">
          <el-select v-model="cityVal" clearable>
            <!-- <el-option v-for="item in cityOptions" :key="item" :label="item" :value="item"></el-option> -->
            <el-option :label="$t('message.tokyoOffice')" value="東京"></el-option>
            <el-option :label="$t('message.osakaOffice')" value="大阪"></el-option>
            <el-option :label="$t('message.KWS1Office')" value="藤井寺"></el-option>
            <el-option :label="$t('message.SWH7Office')" value="市川"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-date-picker v-model="orderDateRange" type="daterange" range-separator=" - "
            :start-placeholder="$t('message.orderTimeStartHolder')" :end-placeholder="$t('message.orderTimeEndHolder')"
            value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="search_item">
          <el-select v-model="containerModel" clearable><el-option v-for="item in modelOptions" :key="item"
              :label="item" :value="item"></el-option></el-select>
        </div>
        <div class="search_item">
          <el-input v-model="containerCoding" :placeholder="$t('message.containerOrderNumber')"></el-input>
        </div>
        <div class="search_item" v-if="$store.state.JHSS.personalUserid.includes('admin')">
          <el-select v-model="searchCustomer" filterable style="margin-left: 20px;"
            :placeholder="$t('message.exportDatePlaceholder') + $t('message.customTableTitle2')">
            <el-option v-for="item in customerLsit" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="search_btn" @click="searchContainerOrder">{{ $t('message.searchBtnText') }}</div>
        <div class="search_btn" @click="kanto_kansai_receipt('return')" v-if="isAdmin">{{
          $t('message.containerReturnReceipt') }}</div>
      </div>
    </div>
    <div class="content">
      <div class="tableBox">
        <el-table id="containerOrder" :data="containerOrder" style="width: 100%" stripe size="small"
          header-cell-class-name="tableHeader" cell-class-name="tableBodyer" v-loading="loading" height="100%"
          @sort-change="sortChange">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"
            fixed="left"></el-table-column>
          <el-table-column :label="$t('message.containerOrderCity')" prop="CITY" width="100"
            fixed="left"></el-table-column>
          <!-- <el-table-column :label="$t('message.containerJOBNO')" prop="JOBNO" width="120"></el-table-column> -->
          <el-table-column :label="$t('message.CarNoTitle')" prop="DDCARNO" width="100" fixed="left"></el-table-column>
          <el-table-column :label="$t('message.containerOrderNumber')" prop="JZXNUM" min-width="200" sortable="custom"
            fixed="left"></el-table-column>
          <el-table-column :label="$t('message.containerGoodsModel')" width="130" sortable="custom" prop="JZXSIZE">
            <template slot-scope="scope">
              <span
                :class="{ 'color1': scope.row.JZXSIZE === '40GP/HQ', 'color2': scope.row.JZXSIZE === '20GP/HQ', 'color3': scope.row.JZXSIZE === 'CFS', 'color4': scope.row.JZXSIZE === 'KIX', 'color5': scope.row.JZXSIZE === 'NRT', 'color6': scope.row.JZXSIZE === 'HND' }">{{
                  scope.row.JZXSIZE }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.containerQueryTitle1')" prop="DADATE" min-width="150"
            sortable="custom"></el-table-column>
          <!-- <el-table-column :label="$t('message.goodsStatus')" prop="goodsStatus" width="120"></el-table-column> -->
          <el-table-column :label="$t('message.customerDedicatedNum')" prop="KRZYBH" width="120"></el-table-column>
          <el-table-column :label="$t('message.placeOfDelivery')" prop="placeOfDelivery" width="150"></el-table-column>
          <el-table-column :label="$t('message.deliveryDate')" prop="deliveryDate" min-width="170"></el-table-column>
          <el-table-column :label="$t('message.containerReturnReceipt')" width="100">
            <template slot-scope="scope">
              <a class="operation_a_blue" @click="checkReturnReceipt(scope.row.ID)">{{ $t('message.orderTableCheckTitle') }}{{ '(' + scope.row.HCDCOT + ')' }}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.containerCreater')" prop="GUDING1" width="100"
            sortable="custom"></el-table-column>
          <el-table-column :label="$t('message.containerOrderCustomer')" prop="KEREN" width="150"
            sortable="custom"></el-table-column>
          <el-table-column :label="$t('message.containerOrderCustomerID')" prop="customerId"
            width="150"></el-table-column>
          <el-table-column :label="$t('message.containerOrderNum')" prop="SHULIANG" width="150"
            sortable="custom"></el-table-column>
          <el-table-column :label="$t('message.containerOrderVolume')" prop="TIJI" width="150"></el-table-column>
          <el-table-column :label="$t('message.containerOrderWeight')" prop="ZHONGLIANG" width="150"></el-table-column>
          <el-table-column :label="$t('message.containerOrderRemark')" prop="REMARK" width="120"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle11')" prop="addTime" min-width="170"></el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="page_no"
        :page-sizes="pageSizes" :page-size="page_size" layout="total, sizes, prev, pager, next" :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
    <el-dialog :title="$t('message.containerOrderAttacherFile')" :visible.sync="showFileDialog" destroy-on-close
      :close-on-click-modal="false" center width="40%">
      <div style="margin-bottom: 10px;">{{ abnormalCondition }}</div>
      <div class="dialog_row" style="display: flex;flex-direction: column;justify-content: center;"
        v-if="!$store.state.JHSS.personalUserid.includes('admin')">
        <div v-for="(file, index) in fileList" :key="index" class="fileUrlBox">
          <!-- <a :href="file.url" target="_blank">{{ file.name }}</a> -->
          <a href="javascript:void(0)" @click="loadMultipleFiles(file.FILENAME, 'HCD')">{{ file.name }}</a>
        </div>
      </div>
      <div class="dialog_row" v-else>
        <div class="dialog_item" style="display: flex;justify-content: center;">
          <el-upload class="uploadBox" :action="uploadFile()" multiple :on-success="returnReceiptSuccess"
            :on-remove="returnReceiptRemove" :on-preview="returnReceiptPreview" :file-list="fileList">
            <el-button size="small" type="primary">{{ $t('message.addFileText') }}</el-button>
          </el-upload>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="receiptDialogTitle" :visible.sync="receiptDialog" destroy-on-close :close-on-click-modal="false"
      center>
      <div class="dialog_box">
        <div class="top_search_part">
          <div class="search_box"></div>
          <div class="search_box">
            <div class="search_btn" @click="downloadmutipleFiles">{{ $t('message.download') }}</div>
          </div>
        </div>
        <div class="content">
          <el-table id="receiptShowList" :data="receiptShowList" style="width: 100%" stripe size="small"
            header-cell-class-name="tableHeader" cell-class-name="tableBodyer" @selection-change="selectReceipt">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="60"></el-table-column>
            <el-table-column :label="$t('message.signatureFormName')" prop="name" min-width="200"></el-table-column>
            <el-table-column :label="$t('message.downloadNumber')" prop="downcot" min-width="60"></el-table-column>
            <el-table-column :label="$t('message.customTableTitle5')" width="120">
              <template slot-scope="scope">
                <div class="operate_btn_box">
                  <el-button class="operation_a_blue" type="text" size="small"
                    @click="loadMultipleFiles(scope.row.FILENAME, 'HCD')">
                    {{ $t('message.download') }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination style="position: unset;" @size-change="receiptSizeChange" @current-change="receiptCurrentChange"
          :current-page="receipt_page_no" :page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="receipt_page_size"
          layout="total, sizes, prev, pager, next" :total="receiptDialogList.length" class="tablePage"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomer, queryContainerOrder, getAbnormalAttachment, getOneDayReturnReceipt, loadMultipleFiles, getReturnReceipt, setReturnReceipt, delReturnReceipt, imgSrc, uploadImg } from '@/api/getData'
export default {
  name: 'containerQuery',
  data() {
    return {
      isAdmin: false,
      cityVal: '',
      cityOptions: ['東京', '大阪'],
      orderDateRange: null,
      containerModel: '',
      modelOptions: ['40GP/HQ', '20GP/HQ', 'CFS', 'NRT', 'KIX', 'HND'],
      containerCoding: '',
      customerLsit: [], // 客户列表
      searchCustomer: '',
      page_no: 1,
      page_size: 50,
      pageSizes: [50, 100, 200, 300, 500],
      totalSize: 0,
      prop: null, // 排序字段
      order: '', // 排序方式
      loading: false,
      containerOrder: [],
      abnormalCondition: '',
      fileList: [],
      showFileDialog: false,
      receiptPid: 0,
      receiptDialogTitle: '',
      receiptDialog: false,
      receiptDialogList: [],
      receiptSelectTable: [],
      receipt_page_no: 1,
      receipt_page_size: 10,
    }
  },
  created() {
    this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin');
    let param = this.$store.state.JHSS_containerQuery_param
    if (param.PAGE) this.page_no = param.PAGE
    if (param.TYPE) this.page_size = param.TYPE
    if (param.CITY) this.cityVal = param.CITY
    if (param.UDADATE && param.DDADATE) this.orderDateRange = [param.UDADATE, param.DDADATE]
    if (param.JZXSIZE) this.containerModel = param.JZXSIZE
    if (param.JZXNUM) this.containerCoding = param.JZXNUM
    this.queryContainerOrder(param)
    this.getCuetomer()
  },
  methods: {
    // 查询客户列表
    async getCuetomer() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      })
      let param = { IFQUERY: '1' }
      let res = await getCustomer(param)
      loading.close()
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
        return
      } else {
        this.customerLsit = res.data.dt.map(item => {
          return {
            label: item.USHOWNAME + '——' + item.GUDING1,
            value: item.USERID
          }
        })
      }
    },
    // 查询货物订单
    async queryContainerOrder(param) {
      this.loading = true
      param = param || {}
      if (this.prop) param.ORDERNAME = this.prop
      param.DOA = this.order
      param.PAGE = this.page_no
      param.TYPE = this.page_size
      param.ADDUSERID = this.$store.state.JHSS.personalUserid
      param.HWXXJS = 'no'
      let res = await queryContainerOrder(param)
      this.loading = false
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        let _this = this
        this.containerOrder = res.data.dt.map(item => {
          item.index = ++index
          let city = !item.THCITY ? '' : item.THCITY
          let address = !item.THDIZHI ? '' : item.THDIZHI
          item.placeOfDelivery = city + ' ' + address
          let date = !item.THDATE ? '' : item.THDATE
          let assign = !item.DDDATE ? '' : item.DDDATE
          item.deliveryDate = date + ' ' + assign
          if (item.GUDING3 === null || item.GUDING3 === '') {
            item.goodsStatus = ''
          } else if (item.GUDING3 === '0') {
            item.goodsStatus = _this.$t('message.notArrive')
          } else {
            item.goodsStatus = _this.$t('message.hasArrive')
          }
          if (item.GUDING4 === null || item.GUDING4 === '') {
            item.condition = ''
          } else if (item.GUDING4 === '0') {
            item.condition = _this.$t('message.abnormalCondition')
          } else {
            item.condition = _this.$t('message.normalCondition')
          }
          item.addTime = item.ADDTIME.replace(/T/g, ' ')
          item.customerId = !item.CUSTOMERID ? '' : item.CUSTOMERID.split(',')[0]
          return item
        })
        this.$store.commit('setContainerQueryParam', param)
      }
    },
    searchContainerOrder() {
      this.searchFun()
    },
    sizeChange(val) {
      this.page_size = val
      this.searchFun()
    },
    currentChange(val) {
      this.searchFun(val)
    },
    searchFun(val) {
      this.page_no = val || 1
      let param = {}
      // 查询客户管理
      if (this.cityVal) param.CITY = this.cityVal
      if (this.orderDateRange) {
        param.UDADATE = this.orderDateRange[0]
        param.DDADATE = this.orderDateRange[1]
      }
      if (this.containerModel) param.JZXSIZE = this.containerModel
      if (this.containerCoding) param.JZXNUM = this.containerCoding
      if (this.searchCustomer) param.CUSTOMERID = this.searchCustomer
      this.queryContainerOrder(param)
    },
    // 时间排序
    sortChange(obj) {
      // console.log(obj)
      // 根据时间排序（prop: addTime ，order: 'ascending', 'descending', null）
      this.prop = null
      if (obj.prop === 'DADATE') {
        this.prop = 'DADATE'
      }
      if (obj.prop === 'SHULIANG') {
        this.prop = 'SHULIANG'
      }
      if (obj.prop === 'GUDING1') {
        this.prop = 'GUDING1'
      }
      if (obj.prop === 'KEREN') {
        this.prop = 'KEREN'
      }
      if (obj.prop === 'JZXNUM') {
        this.prop = 'JZXNUM'
      }
      if (obj.prop === 'JZXSIZE') {
        this.prop = 'JZXSIZE'
      }
      this.order = ''
      if (obj.order === 'descending') {
        this.order = 'DESC'
      }
      if (!obj.order) {
        this.prop = null
      }
      this.searchFun()
    },
    // 查看异常情况附件
    async abnormalCheckUpload(obj) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.abnormalCondition = obj.GUDING5
      let param = { PID: obj.ID }
      let res = await getAbnormalAttachment(param)
      loading.close()
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        console.log(res.data)
        this.fileList = res.data.dt.map(item => {
          item.name = item.FILEOLDNAME
          item.url = imgSrc(item.FILENAME)
          return item
        })
        this.showFileDialog = true
      }
    },
    // 查看回传签收单附件
    async checkReturnReceipt(id) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.abnormalCondition = ''
      let param = { PID: id }
      let res = await getReturnReceipt(param)
      loading.close()
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        // console.log(res.data)
        // this.fileList = res.data.dt.map(item => {
        //   item.name = item.FILEOLDNAME + (item.DOWNTIME ? " " + item.DOWNTIME : "")
        //   item.url = imgSrc(item.FILENAME)
        //   return item
        // })
        this.fileList = res.data.dt.map(item => {
          item.name = item.FILEOLDNAME + (item.DOWNTIME ? " " + item.DOWNTIME.replace(/T/g, ' ') : "")
          return item
        })
        this.receiptPid = id
        this.showFileDialog = true
      }
    },
    // 回传签收单上传成功
    async returnReceiptSuccess(file) {
      // console.log('returnReceiptSuccess', file)
      if (file.result !== '1') {
        this.$message.error('UPLOAD ERROR')
      } else {
        let param = { PID: this.receiptPid, FILENAME: file.data.filename, FILEOLDNAME: file.data.fileoldname }
        let res = await setReturnReceipt(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          this.$message.success('UPLOAD SUCCESS')
          this.checkReturnReceipt(this.receiptPid)
          this.searchFun(this.page_no)
        }
      }
    },
    // 回传签收单删除成功
    async returnReceiptRemove(file) {
      let param = { ID: file.ID }
      let res = await delReturnReceipt(param)
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        this.$message.success('DELETE SUCCESS')
        this.checkReturnReceipt(this.receiptPid)
        this.searchFun(this.page_no)
      }
    },
    returnReceiptPreview(file) {
      //window.open(file.url)
      this.loadMultipleFiles(file.FILENAME, 'HCD')
    },
    async kanto_kansai_receipt(type) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      });

      let param = {
        ADDUSERID: this.$store.state.JHSS.personalUserid
      }
      if (this.cityVal) param.CITY = this.cityVal
      if (this.orderDateRange) {
        param.UDADATE = this.orderDateRange[0]
        param.DDADATE = this.orderDateRange[1]
      }
      if (this.containerModel) param.JZXSIZE = this.containerModel
      if (this.containerCoding) param.JZXNUM = this.containerCoding
      if (this.searchCustomer) param.CUSTOMERID = this.searchCustomer
      let res = await getOneDayReturnReceipt(param)
      loading.close();
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status);
      } else {
        // console.log(res.data)
        let index = 0;
        this.receiptDialogList = res.data.dt.map(item => {
          item.index = ++index;
          item.href = imgSrc(item.FILENAME);
          item.name = item.FILEOLDNAME;
          return item;
        });
        this.receiptSelectTable = [];
        this.receipt_page_no = 1;
        this.receipt_page_size = 10;
        this.receiptDialog = true;
        this.receiptDialogTitle = this.$t('message.containerReturnReceipt');
      }
    },
    receiptSizeChange(val) {
      this.receipt_page_size = val;
    },
    receiptCurrentChange(val) {
      this.receipt_page_no = val;
    },
    selectReceipt(val) {
      this.receiptSelectTable = val;
    },
    async downloadmutipleFiles() {
      if (this.receiptSelectTable.length === 0) {
        this.$message(this.$t('message.exportDatePlaceholder'));
      } else {
        let list = this.receiptSelectTable.map(item => {
          return item.FILENAME;
        });
        this.loadMultipleFiles(list.join(','), 'HCD');
      }
    },
    async loadMultipleFiles(filename, type) {
      // console.log(filename);

      if (!filename) {
        this.$message.error(this.$t('message.noAttachment'));
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      });
      let param = {
        FILENAME: filename,
        FILETYPE: type,
        DOWNLOADUSER: this.$store.state.JHSS.personalUserid
      };
      let res = await loadMultipleFiles(param);
      loading.close();
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status);
      } else if (res.data.result !== '1') {
        this.$message.error(res.data.message);
      } else {
        window.open(imgSrc(res.data.data));
      }
    },
  },
  computed: {
    uploadFile() {
      return uploadImg
    },
    receiptShowList() {
      return this.receiptDialogList.slice((this.receipt_page_no - 1) * this.receipt_page_size, this.receipt_page_no * this.receipt_page_size);
    }
  }
}
</script>

<style scoped>
.color1 {
  color: #0048FF;
}

.color2 {
  color: #00CBC9;
}

.color3 {
  color: #FF8524;
}

.color4 {
  color: #00B7FF;
}

.color5 {
  color: #FFBB00;
}

.color6 {
  color: #9800FF;
}

.abnormalCheck {
  margin-left: 10px;
}

/* 附件弹窗 */
.fileUrlBox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fileUrlBox a {
  margin-top: 20px;
  font-size: 20px;
  color: #0066FF;
}
</style>
